import React from "react";
import { Link } from "react-router-dom";
import "./VehicleListCard.css";

export default function VehicleListCard({ vehicle }) {
  const {
    title,
    imageSrc,
    href,
    shortDescription,
    price,
    engine,
    payload
  } = vehicle;

  return (
    <article className="vehicle-list-card">
      <div className="vehicle-list-card__left">
        <h2 className="vehicle-list-card__name">{title}</h2>

        {shortDescription && (
          <p className="vehicle-list-card__desc">{shortDescription}</p>
        )}

        <h6 className="vat-highlight">Exclusive of VAT*</h6>

        {price && (
          <div className="vehicle-list-card__price">
            <span className="vehicle-list-card__price-value">{price}</span>
          </div>
        )}

        {(engine || payload) && (
          <div className="vehicle-list-card__features">
            {engine && (
              <div className="vehicle-list-card__feature">
                <span className="vehicle-list-card__feature-label">Engine</span>
                <span className="vehicle-list-card__feature-value">
                  {engine}
                </span>
              </div>
            )}
            {payload && (
              <div className="vehicle-list-card__feature">
                <span className="vehicle-list-card__feature-label">Payload</span>
                <span className="vehicle-list-card__feature-value">
                  {payload}
                </span>
              </div>
            )}
          </div>
        )}
      </div>

      <div className="vehicle-list-card__right">
        <div className="vehicle-list-card__image-wrapper">
          <img
            src={imageSrc}
            alt={title}
            className="vehicle-list-card__image"
          />
        </div>

        <div className="vehicle-list-card__actions">
          <Link
            to={href || "#"}
            className="lk-brand-link"
          >
            View Details →
          </Link>
        </div>
      </div>
    </article>
  );
}

